import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { TempStorageService } from "./temp-storage.service";
import { RequestReport } from "../../core";

@Injectable({ providedIn: "root" })
export class BusinessLoginIntegrationService extends TempStorageService {
  /**
   * Creates an instance of business entity service.
   * @param apiService: ApiService
   */
  constructor(public apiService: ApiService) {
    super();
  }

  /**
   * Gets embed token from PowerBI API REST
   * @returns Observable
   */
  getEmbedToken(params: RequestReport) {
    return this.apiService.get(
      `${this.apiService.businessLoginIntegration}/embeddings`
      ,params
    );
  }
}
